import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useBusinessInfo } from "@/lib/businessInfo";
import { Button } from "@/components/ui/button";
import { LogOut, Receipt } from "lucide-react";

export const AppShell = ({ children, title, subtitle }) => {
  const { user, logout } = useAuth();
  const businessInfo = useBusinessInfo();
  const navigate = useNavigate();

  const brandName = businessInfo?.business_name || "BILLING";

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link
            to={user?.role === "admin" ? "/admin" : "/dashboard"}
            className="flex items-center gap-2"
            data-testid="brand-link"
          >
            <div className="w-8 h-8 bg-slate-900 flex items-center justify-center">
              <Receipt className="w-4 h-4 text-white" />
            </div>
            <span className="font-display text-lg font-semibold tracking-tight text-slate-900 uppercase">
              {brandName}
            </span>
          </Link>

          <div className="flex items-center gap-4">
            <div className="hidden sm:flex flex-col items-end">
              <span className="text-sm font-medium text-slate-900" data-testid="header-user-name">
                {user?.name}
              </span>
              <span className="label-tag" data-testid="header-user-role">{user?.role}</span>
            </div>
            <Button
              variant="outline"
              size="sm"
              onClick={handleLogout}
              data-testid="logout-btn"
              className="border-slate-300"
            >
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        {(title || subtitle) && (
          <div className="mb-8">
            {title && (
              <h1 className="font-display text-3xl sm:text-4xl tracking-tight font-light text-slate-900">
                {title}
              </h1>
            )}
            {subtitle && (
              <p className="mt-2 text-slate-500 text-sm sm:text-base">{subtitle}</p>
            )}
          </div>
        )}
        {children}
      </main>
    </div>
  );
};
